import axios from "axios";
import { Config } from "../../data/config";
import {setGeoCity} from './app';

export const SET_GEO = "SET_GEO";
export const setGeo = geo => {
  return { type: SET_GEO, payload: geo };
};

export function getGeo()
{
  return function(dispatch) {
    axios
      .get(`${Config.frontApiUrl}/geoip/self`)
      .then(response => {
        if (response.data.state_name === 'British Columbia') {
          dispatch(setGeoCity(response.data.state_name));
        } else {
          dispatch(setGeoCity(response.data.city));
        }
        dispatch(setGeo(response.data));
      });
  };
}


// WEBPACK FOOTER //
// ./src/store/actions/geo.js